<template>
  <el-dialog
    :title="!dataForm.isE ? '供应商基本信息' : '创建潜在供应商'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="50%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" class="user-info-dialog-form">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商账号" prop="venderLogin">
            <el-input v-model="dataForm.venderLogin"  placeholder="供应商账号" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input v-model="dataForm.venderCode"  placeholder="供应商代码" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商名称" prop="venderName">
            <el-input v-model="dataForm.venderName" placeholder="供应商名称" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商简称" prop="venderAbbreviation">
            <el-input v-model="dataForm.venderAbbreviation" placeholder="供应商简称" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商地址" prop="venderAdd">
            <el-input v-model="dataForm.venderAdd" placeholder="供应商地址" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="venderMail">
            <el-input v-model="dataForm.venderMail" placeholder="邮箱" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="联系人" prop="venderContacts">
            <el-input v-model="dataForm.venderContacts" placeholder="联系人" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商备用邮箱" prop="venderMailBak">
            <el-input v-model="dataForm.venderMailBak" placeholder="供应商备用邮箱" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="联系电话" prop="venderTel">
            <el-input v-model="dataForm.venderTel" placeholder="联系电话" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
        <el-col :span="12">
          <el-form-item label="子公司" prop="subcompanyId">
            <el-select  v-model="dataForm.subcompanyId" @change="getSupCompanyList" style="width: 100%">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="3" v-model="dataForm.remark" placeholder="备注" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col style="text-align: right;" v-if="!dataForm.isE ? false : true">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button type="primary" size="small" @click="dataFormSubmit()" :loading="dataFormSubmitLoading">创建</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,updateSupplierById,createDisposableSupplier} from '@/controller/supplier'
  import {supCompanyList} from "../../../../controller/sys";
  
  export default {
    data () {
      
      return {
        dataFormSubmitLoading:false,
        visible: false,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          isE:'',
          venderCode: '',
          venderName : '',
          venderLogin : '',
          venderCareerBody : '',
          venderAbbreviation : '',
          venderAdd : '',
          venderContacts : '',
          venderMail : '',
          venderMailBak : '',
          venderTel : '',
          venderSource : '',
          remark : '',
          subcompanyId:''
        },
        supCompanyList: [],
        dataRule: {
          // venderCode: [
          //   { required: true, message: '供应商代码不可为空', trigger: 'change' }
          // ],
          venderName: [
            { required: true, message: '供应商名称不可为空', trigger: 'change' }
          ],
          venderAdd: [
            { required: true, message: '供应商地址不可为空', trigger: 'change' }
          ],
          venderContacts: [
            { required: true, message: '供应商联系人不可为空', trigger: 'change' }
          ],
          venderMail: [{
                        required: true,
                        message: '邮箱不能为空',
                        trigger: 'blur'
                    }, {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur']
                    }],
          venderTel: [
            { required: true, message: '供应商联系电话不可为空', trigger: 'change' }
          ],
          subcompanyId: [
            { required: true, message: '子公司不可为空', trigger: 'change' }
          ],
        }
      }
    },
    methods: {
      init (row) {
        this.visible = true
        this.getSupCompanyList();
        this.dataForm.id = row.id || 0
        this.dataForm.isE = row.isE
        this.$nextTick(() => {


            this.$refs['dataForm'].resetFields()
            // this.dataForm.tenantId = sessionStorage.getItem('tenantId')
            // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            //this.dataForm.userTypeList = []
          
        selectSupplierById(
                  {id : this.dataForm.id}
           ).then(data => {
             if (data && data.code === '00') {
               this.dataForm = {...this.dataForm, ...data.body}
             }
           })
        
        })
      },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
          }
        })
      },
      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let params = {
              //'id': this.dataForm.id || undefined,
              //'venderCode': this.dataForm.venderCode,
              'venderName': this.dataForm.venderName,
              'venderLogin': this.dataForm.venderLogin,
              'venderCareerBody': this.dataForm.venderCareerBody,
              'venderAbbreviation': this.dataForm.venderAbbreviation,
              'venderAdd': this.dataForm.venderAdd,
              'venderContacts': this.dataForm.venderContacts,
              'venderMail': this.dataForm.venderMail,
              'venderMailBak': this.dataForm.venderMailBak,
              'venderTel': this.dataForm.venderTel,
              'venderSource': this.dataForm.venderSource,
              'remark': this.dataForm.remark,
               'subcompanyId':this.dataForm.subcompanyId
            }
            this.dataFormSubmitLoading = true
              createDisposableSupplier(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.dataFormSubmitLoading = false
                  this.$message({
                    message: '修改成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.dataFormSubmitLoading = false
                  this.$message.error(data.msg)
                }
              }).catch((e) => {this.dataFormSubmitLoading = false}).finally(()=>{
                this.dataFormSubmitLoading = false
              })
            
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>